import Experiment, { useExperimentVariables } from '@mc/experiments-react'
import { MCCERTS_2279_FLAG } from '../constants'
import type { ClipBounds, Mccerts2279Variables } from '../types'
import { HeroTrailerLoop } from './HeroTrailerLoop'

interface Props {
  mediaUuid: string
  posterUrl?: string
  paused?: boolean
  certSlug: string
}

// Eligibility is "any cert landing page that has a trailer" — the call sites
// gate on `trailerMediaUuid` and nothing else, so the flag only decides
// control vs variant_1. No app-side slug allowlist, and no URL targeting on
// the GrowthBook rule either.
//
// Rendered from both hero paths (components/MarketingCertPage/HeroSection and
// mccerts-2548's HeroVariant) so this experiment stays independent of that
// one's bucket.
const Variant1 = ({ mediaUuid, posterUrl, paused, certSlug }: Props) => {
  const variables =
    useExperimentVariables<Mccerts2279Variables>(MCCERTS_2279_FLAG)
  const clip = (variables[certSlug] ?? {}) as ClipBounds

  return (
    <HeroTrailerLoop
      mediaUuid={mediaUuid}
      posterUrl={posterUrl}
      paused={paused}
      startTime={clip.startTime}
      endTime={clip.endTime}
    />
  )
}

export const HeroTrailerLoopExp = ({
  mediaUuid,
  posterUrl,
  paused,
  certSlug,
}: Props) => (
  <Experiment
    name={MCCERTS_2279_FLAG}
    control={() => null}
    variant_1={() => (
      <Variant1
        mediaUuid={mediaUuid}
        posterUrl={posterUrl}
        paused={paused}
        certSlug={certSlug}
      />
    )}
  />
)
